// extracted by mini-css-extract-plugin
export default {"MfaInput":"LoginForm_MfaInput__xcES5"};